import { render, staticRenderFns } from "./localEvents.vue?vue&type=template&id=3f25dd50"
import script from "./localEvents.vue?vue&type=script&lang=js"
export * from "./localEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports